export const api = {
  authentication: {
    register: "register",
    login: "login",
    fetchUser: "users/:userId",
    passwordReset: "password_reset/",
    passwordResetConfirm: "password_reset/confirm/",
  },
  PDF: {
    TotalStatements: "statements/get_total_statements",
    capabilityStatement: "statements/capability_statement",
    capabilityStatementCreate: "statements/capability_statement_create",
    DeleteStatement: "statements/delete_statement",
  },
  proposals: {
    saveProposal: "proposals",
    getAllProposal: "proposals",
    getProposal: "proposals/:proposalId",
    deleteProposal: "proposals/:proposalId",
    updateProposal: "proposals/:proposalId",
    createSubscription: "proposals/subscription",
    aiTemplate: "proposals/ai_template"
  },
  site_visits: {
    getAllSiteVisit: "site_visits",
    saveSiteVisit: "site_visits",
    getSiteVisit: "site_visits/:siteVisitId",
    getSiteVisitByProject: "site_visits/:siteVisitProject",
    updateSiteVisit: "site_visits/:siteVisitId",
    deleteSiteVisit: "site_visits/:siteVisitId",
    downloadSiteVisit: "site_visits/download/:siteVisitId"
  },
  projectTypes: {
    getAllProjectTypes: "project-types",
    getAllUserProjectTypes: "project-types/user",
    getProjectTypes: "project-types/:projectTypeId",
  },
  proposalTemplates: {
    getAllTemplates: "paint_proposals/templates",
    saveProposal: "paint_proposals/proposal",
    getAllProposals: "paint_proposals/proposal",
    getProposal: "paint_proposals/proposal/:proposalId",
    updateProposal: "paint_proposals/proposal/:proposalId",
    deleteProposal: "paint_proposals/proposal/:proposalId"
  },
  users: {
    updateUser: "users/:userId",
    editUser: "users/profile",
    freeMode: "users/free_mode_action",
    lifetimeOffer: "users/lifetime_offer",
    freeModeSqFt: "users/free_sqft_changes",
    manageUserBilling: "users/create-customer-portal-session",
    dashboard: "users/page-dashboard",
    saveDashboard: "users/save-dashboard",
    favoriteProjectsPaginated: "users/favorite-projects",
    favoriteProjectsSummary: "users/favorite-projects-summary"

  },
  projects: {
    all: "projects",
    list: "projects/list",
    search: "projects/search",
    byLocations: "projects?coordinates=:locations",
    singleProject: "projects/:projectId",
    archiveProject: "projects/:projectId/archive",
    unArchiveProject: "projects/:projectId/unarchive",
    likeProject: "projects/:projectId/favorite",
    unLikeProject: "projects/:projectId/unfavorite",
    saveSearchProject: "projects/save-search",
    deleteSearchProject: "projects/delete-search/:search-id?userId=:user-id",
    saveComment: "project/:projectId/comments",
    getComment: "project/:projectId/comments",
    deleteComment: "project/:projectId/comments/:commentId",
    editComment: "project/:projectId/comments/:commentId",
    saveStatus: "user-projects-status",
    saveSequnce: "projects/save-sequence",
    addSiteRoute: "projects/:projectId/site_route",
    removeSiteRoute: "projects/:projectId/remove_site_route",
    updateNotes: "projects/site_route_notes/0",
    updateLastContact: "projects/contact_last_date/0",
    projectNotes: "projects/project_notes/:projectId",
    projectVisit: "projects/project_visit/:projectId",
    addActivity: "projects/add_activity/0",
    deleteActivity: "projects/delete_activity/:activityId",
    labels: "projects/:projectId/labels",
    labelNames: "projects/label-names",
    labelSummary: "projects/label-summary",
    labelProjects: "projects/labels/:color/projects",
    generateAiDescription: "projects/:projectSlug/ai_description",
  },
  callLogs: {
    saveCallLog: "project/:projectId/call-logs",
    allCallLogs: "project/:projectId/call-logs",
  },
  userEmailTemplates: {
    list: "user-email-templates/",
    detail: "user-email-templates/:templateKey/",
    order: "user-email-templates/order/",
  },
  contact: {
    getEmailTemplate: "email-templates/:templateId",
    sendEmailToContactAPI: "project/:projectId/emails",
    sendEmailToGeneralContractorContact: "contacts/:contactId/emails",
    getEmailLogs: "project/:projectId/emails",
    getContactRoles: "project/:projectId/contact-roles",
    getAvailableContacts: "project/:projectId/contact-roles/available",
    addContactPreference: "project/:projectId/contact-roles/preferences",
    removeContactPreference: "project/:projectId/contact-roles/preferences",
    deleteUserContact: "contacts/:contactId/delete",
    deleteUserCompany: "contacts/:contactId/delete_company",
  },
  deal: {
    createDeal: "deals/create_deal",
    getDeal: "deals/:dealId",
    getDeals: "deals/marketplace",
    updateDeal: "deals/:dealId",
    deleteDeal: "deals/:dealId",
    updateStatus: "deals/:dealId/update_status",
    addDeal: "deals/:dealId/add_deal",
    addStripeAccount: "deals/create-stripe-account",
    stripePayout: "deals/create-payout",
    // Gmail ITB Import
    gmailConnectionStatus: "deals/gmail/status",
    gmailConnect: "deals/gmail/connect",
    gmailDisconnect: "deals/gmail/disconnect",
    scanGmailInbox: "deals/gmail/scan",
    scanGmailInboxStatus: "deals/gmail/scan/status",
    listStagedITBs: "deals/itbs/staged",
    importITBs: "deals/itbs/import",
    importITBsStatus: "deals/itbs/import/status",
    rejectITB: "deals/itbs/:itbId/reject",
  },
  replies: {
    saveReply: "comments/:commentId/replies",
    editReply: "comments/:commentId/replies/:replyId",
    deleteReply: "comments/:commentId/replies/:replyId",
  },
  notification: {
    getNotifications: "project-notifications",
  },
  hotScopes: {
    getHotScopes: "projects/hotscopes",
  },
  regions: {
    getRegions: "gc_qualify/regions",
  },

  mortgageCalculator: {
    getBidAmountPricing:
      "mortgage_calculator/bidamount_pricing/:projectType?phase=:phase",
    getStateLaborPricing: "mortgage_calculator/state_labor_pricing/:state",
    getStateLaborPricingList: "mortgage_calculator/state_labor_pricing",
    getProjectTypePricingList: "mortgage_calculator/bidamount_pricing",
    saveEstimates: "mortgage_calculator/cleanup_estimates",
    getAllEstimates: "mortgage_calculator/cleanup_estimates",
    getEstimates: "mortgage_calculator/cleanup_estimates/:id",
    deleteEstimates: "mortgage_calculator/cleanup_estimates/:id",
    updateEstimates: "mortgage_calculator/cleanup_estimates/:id",
    calculationInfo: "mortgage_calculator/calculation_info",
  },
  gcQualify: {
    regions: "gc_qualify/regions",
    companies: "projects/companies?region=:region",
    updatePlanRoom: "gc_qualify/plan_rooms",
    updatePreQualify: "gc_qualify/pre_qualify_create",
  },
  crm: {
    getAllContacts: "contacts/crm",
    createContact: "contacts/crm",
    getContact: "contacts/crm/:contactId/",
    updateContact: "contacts/crm/:contactId/",
    deleteContact: "contacts/crm/:contactId/",
  },
  enrich: {
    getAllContacts: "contacts/enrich",
    enrichContacts: "contacts/enrich",
  }
};

export const TOTAL_FREE_MODE_COUNT = 10;
